export function validateTelInputs() {
    let inputs = document.querySelectorAll("input[type='tel']");

    for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i];

        input.addEventListener("change", function(e) {
            let value = this.value;
            console.log(value);

            if(value.includes("+")) {
                this.setAttribute("minlength", 13);
            } else {
                this.setAttribute("minlength", 9);
            }
        })
    }
}